import { format } from "date-fns";
import { useMemo } from "react";
import { addDays, getValidDates } from "../../../../helpers/date.js";
export const useDatesDefaultValue = (dates, defaultStartDate, defaultEndDate)=>{
    const releaseDays = dates?.releaseDays && dates?.releaseDays !== 0 ? dates.releaseDays : 7;
    const datesDefaultValue = useMemo(()=>getValidDates(defaultStartDate ?? new Date(format(new Date(), 'yyyy-MM-dd')), defaultEndDate ?? addDays(new Date(format(new Date(), 'yyyy-MM-dd')), releaseDays), dates), [
        dates,
        defaultEndDate,
        defaultStartDate,
        releaseDays
    ]);
    return datesDefaultValue;
};
export default useDatesDefaultValue;

//# sourceMappingURL=useDatesDefaultValue.js.map